import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetDescriptionAction } from '../../../../ts/ServerApi/types/actionNames';
import { setDataQualityAction } from '../../../actions/spaces/SetDataQualityAction';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const SetDataQualityAction: IEntityAction<IContentInfo, ISetDescriptionAction> = {
  name: 'setDataQuality',
  translateName: Messages.dataQuality_action,
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQuality was called without exactly one item');
    }

    return setDataQualityAction(items[0]);
  }
};
